import { render, staticRenderFns } from "./m-order-confirmation-template-gallery.vue?vue&type=template&id=7f5f9536&scoped=true&"
import script from "./m-order-confirmation-template-gallery.vue?vue&type=script&lang=js&"
export * from "./m-order-confirmation-template-gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5f9536",
  null
  
)

export default component.exports